import moment from 'moment'

const helpers = {
  // Generate unique GUID
  guid() {
    const s4 = function() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1)
    }
    return (
      s4() +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      s4() +
      s4()
    )
  },

  // Convert from Geo Position object to plain JS object
  // Could be a Position (wraps Coordinate as coords) or just a Coordinate
  positionToPlain(input) {
    //console.log('Input.........', input)
    const pos = input.coords || input
    return {
      accuracy: pos.accuracy,
      altitude: pos.altitude || 0,
      altitudeAccuracy: pos.altitudeAccuracy,
      heading: pos.heading,
      latitude: pos.latitude,
      longitude: pos.longitude,
      speed: pos.speed,
      distance_to_site: pos.distance_to_site,
      eta: pos.eta,
      guid: helpers.guid(),
      timestamp: moment().unix()
    }
  },

  // Help function for creation request to FCM
  urlB64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
    const base64 = (base64String + padding)
      .replace(/-/g, '+')
      .replace(/_/g, '/')

    const rawData = window.atob(base64)
    const outputArray = new Uint8Array(rawData.length)

    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i)
    }
    return outputArray
  },

  dataURItoBlob(dataURI) {
    const bytes =
      dataURI.split(',')[0].indexOf('base64') >= 0
        ? atob(dataURI.split(',')[1])
        : unescape(dataURI.split(',')[1])
    const mime = dataURI
      .split(',')[0]
      .split(':')[1]
      .split(';')[0]
    const max = bytes.length
    const ia = new Uint8Array(max)
    for (let i = 0; i < max; i += 1) ia[i] = bytes.charCodeAt(i)
    return new Blob([ia], { type: mime })
  },

  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], filename, { type: mime })
  },

  resizeImage(file, maxWidth, maxHeight) {
    const reader = new FileReader()
    const image = new Image()
    const canvas = document.createElement('canvas')

    const resize = () => {
      let { width, height } = image
      if (width > height) {
        if (width > maxWidth) {
          height *= maxWidth / width
          width = maxWidth
        }
      } else if (height > maxHeight) {
        width *= maxHeight / height
        height = maxHeight
      }

      canvas.width = width
      canvas.height = height
      canvas.getContext('2d').drawImage(image, 0, 0, width, height)

      const dataUrl = canvas.toDataURL('image/jpeg')

      return dataUrl
    }

    return new Promise((ok, no) => {
      if (!file.type.match(/image.*/)) {
        no(new Error('Not an image'))
        return
      }

      reader.onload = readerEvent => {
        image.onload = () => ok(resize())
        image.src = readerEvent.target.result
      }

      reader.readAsDataURL(file)
    })
  },

  resizeImageFromBase64(datas, maxWidth, maxHeight) {
    return new Promise((resolve, reject) => {
      // We create an image to receive the Data URI
      var img = document.createElement('img')
      // When the event "onload" is triggered we can resize the image.
      img.onload = function() {
        // We create a canvas and get its context.
        let canvas = document.createElement('canvas')
        let ctx = canvas.getContext('2d')
        let ratio = this.width / this.height
        // We set the dimensions at the wanted size.
        if (this.width >= this.height) {
          canvas.width = maxWidth
          canvas.height = maxWidth / ratio
        } else {
          ratio = this.height / this.width
          canvas.width = maxHeight / ratio
          canvas.height = maxHeight
        }
        // We resize the image with the canvas method drawImage();
        ctx.drawImage(this, 0, 0, canvas.width, canvas.height)
        const dataURI = canvas.toDataURL()
        resolve(dataURI)
      }
      // We put the Data URI in the image's src attribute
      img.src = datas
    })
  }
}
export default helpers
